//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { folderShareApi, folderShareUserApi } from '@/api/user';
export default {
  name: 'ShareDialog',
  components: {
    // department: () => import('@/components/departmentTree')
  },
  props: {
    fromData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      lookCheck: false,
      downloadCheck: false,
      editCheck: false,
      dialogData: [],
      openStatus: false,
      userList: [],
      activeDepartment: {},
      where: {
        page: 1,
        limit: 15
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    handleClose: function handleClose() {
      this.resetCheck();
      this.dialogVisible = false;
    },
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    // 选择部门关闭
    departmentClose: function departmentClose() {
      this.openStatus = false;
    },
    // 选择成员完成回调
    changeMastart: function changeMastart(data) {
      var _this = this;
      this.userList = data.userList;
      this.shareArray = [];
      if (this.userList.length > 0) {
        this.userList.map(function (value) {
          if (value.isCheck) {
            _this.$set(value, 'downloadCheck', false);
            _this.$set(value, 'editCheck', false);
          }
        });
      }
      this.openStatus = false;
    },
    // 打开选择部门成员
    openDepartment: function openDepartment() {
      this.$refs.department.reseatData();
      this.openStatus = true;
    },
    handleAdd: function handleAdd() {
      if (this.userList.length <= 0) {
        this.$message.error(this.$t('file.placeholder04'));
      } else {
        var list = [];
        this.userList.forEach(function (value) {
          list.push({
            uid: value.card.uid,
            download: value.downloadCheck ? 1 : 0,
            update: value.editCheck ? 1 : 0
          });
        });
        this.getFolderShare(this.fromData.id, {
          rule: list
        });
      }
    },
    lookChange: function lookChange() {
      this.lookCheck ? this.checkAll('lookCheck') : this.checkNone('lookCheck');
    },
    downloadChange: function downloadChange() {
      this.downloadCheck ? this.checkAll('downloadCheck') : this.checkNone('downloadCheck');
    },
    editChange: function editChange() {
      this.editCheck ? this.checkAll('editCheck') : this.checkNone('editCheck');
    },
    // 全选
    checkAll: function checkAll(items) {
      this.userList.forEach(function (item) {
        item[items] = true;
      });
    },
    // 反选
    checkNone: function checkNone(items) {
      this.userList.forEach(function (item) {
        item[items] = false;
      });
    },
    resetCheck: function resetCheck() {
      this.lookCheck = false;
      this.downloadCheck = false;
      this.editCheck = false;
    },
    deleteShare: function deleteShare(index) {
      this.userList.splice(index, 1);
      if (this.userList.length <= 0) {
        this.resetCheck();
      }
    },
    // 分享
    getFolderShare: function getFolderShare(id, data) {
      var _this2 = this;
      folderShareApi(id, data).then(function (res) {
        _this2.handleClose();
        _this2.$emit('isOk');
        _this2.userList = [];
      });
    },
    getRule: function getRule() {
      this.getFolderShareRule(this.fromData.id);
    },
    // 权限列表
    getFolderShareRule: function getFolderShareRule(id) {
      var _this3 = this;
      var data = {
        page: this.where.page,
        limit: this.where.limit
      };
      folderShareUserApi(id, data).then(function (res) {
        _this3.userList = [];
        if (res.data.list.length > 0) {
          res.data.list.forEach(function (value) {
            var data = {
              card: value.user,
              id: value.to_uid,
              isCheck: false,
              lookCheck: value.auth.read === 1,
              downloadCheck: value.auth.download === 1,
              editCheck: value.auth.update === 1
            };
            value.auth.download === 1 ? _this3.downloadCheck = true : _this3.downloadCheck = false;
            value.auth.update === 1 ? _this3.editCheck = true : _this3.editCheck = false;
            _this3.userList.push(data);
          });
        }
      });
    }
  }
};